import { render, staticRenderFns } from "./DroppableItem.vue?vue&type=template&id=63ffab33&scoped=true&"
import script from "./DroppableItem.vue?vue&type=script&lang=js&"
export * from "./DroppableItem.vue?vue&type=script&lang=js&"
import style0 from "./DroppableItem.vue?vue&type=style&index=0&id=63ffab33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ffab33",
  null
  
)

export default component.exports